import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppointment } from '../context/appointmentContext';
import { usePostMessage, useReceiveMessage } from '../context/messageContext';
import { useResultData } from '../helpers/useResultData';
import { SessionLobby } from './session/Lobby';

const Welcome = () => {
  let navigate = useNavigate();
  const { appointment } = useAppointment();
  const params = useParams();
  const postMessage = usePostMessage();
  const receivedMessage = useReceiveMessage();
  const { clearAllResults } = useResultData();

  useEffect(() => {
    clearAllResults();
  }, [clearAllResults]);

  useEffect(() => {
    if (appointment?.currentUser?.role !== 'patient') return;
    switch (receivedMessage?.type) {
      case 'calibration-selection':
      case 'screen-calibration':
      case 'camera-calibration':
      case 'stepCardCalibration':
      case 'stepRulerCalibration':
      case 'blindspot':
      case 'visualAcuityTest':
      case 'randomE':
      case 'optimaChart':
      case 'contrastSensitivity':
      case 'holding':
      case 'endOfTest':
        navigate(`${process.env.PUBLIC_URL}/patient`);
        break;
      case 'opticianLoggedOut':
        return navigate(`${process.env.PUBLIC_URL}/error`, {
          state: { error: 'This session has been closed. Close your browser to end the appointment.', title: 'Session closed' },
        });
      case 'heartBeat':
        postMessage({ type: 'heartBeatResponse', room_name: receivedMessage?.room_name });
        break;
      default:
        break;
    }
  }, [appointment, postMessage, receivedMessage, navigate]);

  useEffect(() => {
    // check room_name in url, if different from room_name in local storage, update local storage
    const roomName = localStorage.getItem('room_name') || null;
    const newRoomName = params?.roomName || null;

    if (newRoomName !== roomName && newRoomName !== null) {
      localStorage.setItem('room_name', newRoomName);
    }
  }, [appointment, params?.roomName]); // when the context appointment state changes, it fires the useEffect

  useEffect(() => {
    if (!appointment) return;
    return postMessage({ type: 'welcomeScreen', senderRole: appointment?.currentUser?.role !== 'patient' ? 'clinician' : 'patient' });
  }, [postMessage, appointment]);

  // C1 / P1 lobby (IBISengage). Session logic above is unchanged.
  return !appointment ? null : <SessionLobby />;
};

export default Welcome;
